export let pending: Array<Api.PendingType> = [];

export const removeRepeatPending = (config) => {
  for (const key in pending) {
    const item = +key;
    const list = pending[key];
    if (
      list.url === config.url &&
      list.method === config.method &&
      JSON.stringify(list.params) === JSON.stringify(config.params) &&
      JSON.stringify(list.data) === JSON.stringify(config.data)
    ) {
      list.cancel();
      pending.splice(item, 1);
    }
  }
};

export const removePending = () => {
  setTimeout(() => {
    for (const key in pending) {
      const item = +key;
      const list = pending[key];
      list.cancel();
    }
    pending = [];
  }, 0);
};
